import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { request, gql, Variables } from 'graphql-request';

import { QueryKeys } from 'src/constants/queryKeys';

import { PairDayData } from '@app/types/pool';
import { useConfig } from '@app/config';

const fetcher = async (
  baseUrl: string,
  params: Variables = {
    ids: ''
  }
) => {
  const res = await request<{ pairDayDatas: PairDayData[] }>(
    `${baseUrl}`,
    gql`
      query {
        pairDayDatas(
          where: {
            and: [
              {
                pairAddress_in: [${params.ids}]
              },
              {
                date_gt: ${Math.floor(
                  (new Date().getTime() - 60 * 60 * 48 * 1000) / 1000
                )}
              }
            ]
          }
          orderBy: date
          orderDirection: desc
          skip: 0
          first: 1000
        ) {
          id
          pairAddress
          totalSupply
          dailyFeeUSD
          dailyVolumeUSD
          date
          dailyVolumeToken0
          dailyVolumeToken1
          dailyTxns
          reserveUSD
        }
      }
    `,
    params
  );

  return res?.pairDayDatas ? res.pairDayDatas : null;
};

export const usePairsDayData = (
  params: Variables = {},
  options: UseQueryOptions<PairDayData[] | null> = {}
) => {
  const config = useConfig();

  return useQuery<PairDayData[] | null>(
    [QueryKeys.PAIR_DAY_DATA, { params }],
    async () => {
      return fetcher(config?.URLS.subgraphUrl as string, {
        ...params
      });
    },
    {
      enabled: !!params.ids,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
